<template>
  <!-- Modal -->
  <Modal id='addWkContentModal' :savePromise="save" :prepareFunc="prepare" :haveChange="hvChangeFunc">
    <template #button>
      <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-js-ripple-effect mdl-button--colored">
        <i class = 'material-icons'>add</i>
        <span class = 'mdl-button__ripple-container'><span class = 'mdl-ripple'></span></span>
      </button>
    </template>
    <template #content>
      <h5 style='text-align:center'>新增任務</h5>
      <div class='modal-body'>
        <form name='add_form_wk' id='add_form_wk' method='POST'>
          <div style="text-align: right;">
            <md-switch v-model="isAdvanceMode">進階翻轉模式</md-switch>
          </div>
          <div class='input-group form-group'>
            <label class='input-group-addon' for='week_title'>任務名稱*</label>
            <input type='text' v-model="title" id='week_title' name='title' class='form-control'>
          </div>
          <div v-show="!isAdvanceMode" class='row'>
            <div class='col-md-6'>
              <div class='input-group form-group date'>
                <label class='input-group-addon' for='deadline_datetime'>截止日期*</label>
                <!-- <input class='form-control' type='text' name='deadline_datetime' id='deadline_datetime'> -->
                <date-picker v-model="deadline_datetime" :config="options"></date-picker>
              </div>
            </div>
          </div>
          <div v-show="isAdvanceMode" class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group form-group date">
                    <label class="input-group-addon" for="key_day_start_datetime">上課時間*</label>
                    <date-picker v-model="starting_datetime" :config="options"></date-picker>
                    <!-- <input class="form-control" type="text" name="key_day_start_datetime" id="key_day_start_datetime" /> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group form-group">
                    <label class="input-group-addon" for="last_time">上課時數</label>
                    <div class="form-control" style="padding: 0;">
                      <input type="number" min="1" name="last_time" id="last_time" v-model="lastTime" style="display: inline; width: 85%; max-width: calc( 100% - 63px ); height: 100%; float: left;" />
                      <select style="display: inline; width: 15%; min-width: 63px; height: 100%; float: left;" name="last_time_unit" v-model="lastTimeUnit">
                        <option value="mins">分鐘</option>
                        <option value="hours">小時</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group form-group">
                <label class="input-group-addon" for="pre_class_time">上課前</label>
                <div class="form-control" style="padding: 0;">
                  <input type="number" name="pre_class_time" id="pre_class_time" min="1" v-model="preClassTime" style="display: inline; width: 85%; max-width: calc( 100% - 63px ); height: 100%; float: left;" />
                  <select style="display: inline; width: 15%; min-width: 63px; height: 100%; float: left;" name="pre_class_time_unit" v-model="preClassTimeUnit">
                    <option value="hours">小時</option>
                    <option value="days">日</option>
                  </select>
                </div>
                <label class="input-group-addon" for="pre_class_time">開放任務</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group form-group">
                <label class="input-group-addon" for="post_class_time">下課後</label>
                <div class="form-control" style="padding: 0;">
                  <input type="number" name="post_class_time" id="post_class_time" min="1" v-model="postClassTime" style="display: inline; width: 85%; max-width: calc( 100% - 63px ); height: 100%; float: left;" />
                  <select style="display: inline; width: 15%; min-width: 63px; height: 100%; float: left;" name="post_class_time_unit" v-model="postClassTimeUnit">
                    <option value="hours">小時</option>
                    <option value="days">日</option>
                  </select>
                </div>
                <label class="input-group-addon" for="pre_class_time">關閉任務</label>
              </div>
            </div>
            <!-- <div class="col-md-6">
              <div class="input-group form-group date">
                <label class="input-group-addon" for="released_datetime">發布時間</label>
                <date-picker v-model="released_datetime" :config="options"></date-picker>
              </div>
            </div> -->
          </div>
          <div>
            <md-field>
            <label>簡介（選填）</label>
              <md-textarea id='add_week_description' name='description' v-model='description'></md-textarea>
            </md-field>
          </div>
        </form>
        <div class="form-group row" style="padding-bottom: 30px;">
          <div class="col-xs-6" style="text-align: center;">
             <el-button plain data-dismiss="modal">取消</el-button>
          </div>
          <div class="col-xs-6" style="text-align: center;">
             <el-button class="save-btn" type="primary" data-dismiss="modal">儲存</el-button>
          </div>
        </div>
      </div>
    </template>
</Modal>
</template>
<script>
import Modal from '@/components/Utility/Modal'
// require('bootstrap')
var moment = require('moment')
// import Vue from 'vue'
// import Vue from 'vue'
// import WeekCell from '@/components/Teacher/Activities/WeekCell.vue'
export default {
  components: {
    Modal
  },
  props: {
    courseId: Number
  },
  data () {
    return {
      isAdvanceMode: false,
      options: {
        minDate: moment(),
        format: 'YYYY-MM-DD hh:mm A'
      },
      title: '',
      description: '',
      starting_datetime: '',
      deadline_datetime: '',
      released_datetime: '',
      preClassTime: 3,
      preClassTimeUnit: 'days',
      lastTime: 1,
      lastTimeUnit: 'mins',
      postClassTime: 3,
      postClassTimeUnit: 'days',

      save: async (modal, e) => {
        console.log(e)
        e.preventDefault()
        var fd = new FormData(modal.find('form')[0])
        console.log(Object.entries(fd))
        console.log(this.starting_datetime, moment(this.starting_datetime, 'YYYY-MM-DD HH:mm A'), moment(this.starting_datetime, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss'))
        console.log(this.deadline_datetime, moment(this.deadline_datetime, 'YYYY-MM-DD HH:mm A'), moment(this.deadline_datetime, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss'))
        console.log(this.released_datetime, moment(this.released_datetime, 'YYYY-MM-DD HH:mm A'), moment(this.released_datetime, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss'))
        fd.append('mode', this.isAdvanceMode ? 'advance' : 'simple')
        fd.append('key_day_start_datetime', moment(this.starting_datetime, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss'))
        fd.append('deadline_datetime', moment(this.deadline_datetime, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss'))
        // fd.append('released_datetime', moment(this.released_datetime, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss'))
        fd.append('pre_class_time', this.preClassTime)
        fd.append('pre_class_time_unit', this.preClassTimeUnit)
        fd.append('post_class_time', this.postClassTime)
        fd.append('post_class_time_unit', this.postClassTimeUnit)

        var data = Array.from(fd.entries()).reduce((acc, cur) => {
          acc[cur[0]] = cur[1].trim()
          return acc
        }, {})
        console.log(data)
        if (data.title.length === 0) {
          alert('請填寫資料。')
          return false
        }
        if (!this.isAdvanceMode && (this.deadline_datetime === null || this.deadline_datetime.length === 0)) {
          alert('請填寫資料。')
          return false
        }
        if (this.isAdvanceMode && (this.starting_datetime === null || this.starting_datetime.length === 0)) {
          alert('請填寫資料。')
          return false
        }
        // console.log(this.isAdvanceMode, this.starting_datetime, this.released_datetime, moment(this.released_datetime, 'YYYY-MM-DD HH:mm A').isSameOrBefore(moment(this.starting_datetime, 'YYYY-MM-DD HH:mm A').subtract(this.preClassTime, this.preClassTimeUnit)))
        // if (this.isAdvanceMode) {
        //   if (moment(this.released_datetime, 'YYYY-MM-DD HH:mm A').isAfter(moment(this.starting_datetime, 'YYYY-MM-DD HH:mm A').subtract(this.preClassTime, this.preClassTimeUnit))) {
        //     alert('時間邏輯有錯！')
        //     return false
        //   }
        // } else {
        //   if (moment(this.deadline_datetime, 'YYYY-MM-DD HH:mm A').isBefore(Date.now())) {
        //     alert('時間邏輯有錯！')
        //     return false
        //   }
        // }
        let deadline = moment(this.deadline_datetime, 'YYYY-MM-DD HH:mm A')
        if (this.isAdvanceMode) {
          deadline = moment(this.starting_datetime, 'YYYY-MM-DD HH:mm A')
          deadline.add(this.lastTime, this.lastTimeUnit)
          deadline.add(this.postClassTime, this.postClassTimeUnit)
        }
        console.log(deadline.format())
        try {
          let week = await this.$store.dispatch('request', {
            method: 'post',
            route: `courses/${this.courseId}/weeks`,
            data: fd
          })
          this.$parent.addWeek({
            id: week.id,
            title: data.title,
            description: data.description,
            noOfActivities: 0,
            deadline: deadline.format('D MMM'),
            uri: `courses/${this.courseId}/weeks/${week.id}`,
            files: []
          })
          alert('成功')
          return true
          // $('#addWkContentModal').modal('hide')
        } catch (err) {
          console.error(err)
          alert('失敗')
          return false
        }
      },
      prepare: (modal) => {
        console.log(modal.find('input'))
        console.log(modal.find('form').find('input'))
        this.title = ''
        this.description = ''
        this.starting_datetime = ''
        this.deadline_datetime = ''
        this.released_datetime = ''
        this.isAdvanceMode = false

        console.log(this.starting_datetime)
        console.log(this.deadline_datetime)
        console.log(this.released_datetime)
        // this.description = this.week.description
      },
      hvChangeFunc: () => {
        var isEmpty = (str) => str === null || str.length === 0
        return !isEmpty(this.starting_datetime) || !isEmpty(this.deadline_datetime) || !isEmpty(this.released_datetime)
      }
    }
  }
}
</script>
